import { Typography } from '@mui/material';
import { ErrorStack } from './ErrorStack';

interface ErrorMessageProps {
  error: Error;
  showStack?: boolean;
}

export const ErrorMessage = (props: ErrorMessageProps) => (
  <>
    <Typography color='error' component='span'>
      {props.error.message}
    </Typography>
    {props.showStack && props.error.stack && <ErrorStack stack={props.error.stack} />}
  </>
);
